module.exports = {
    "dismiss": `Kapat`
};


//# sourceMappingURL=tr-TR.main.js.map
